import { useState } from 'react';
import { agencyAPI } from '../../../../utilities/api';
import { Agency } from '../../../../utilities/interfaces/Agency';
import CustomDialog from '../../../../components/stateless/dialog/CustomDialog';
import TextField from '../../../../components/stateful/textField/TextField';
import { useNotificationHelper } from '../../../../utilities/helpers/NotificationHelper';

type Props = { open: boolean; closeDialog: () => void };

export const AddAgencyDialog = (props: Props) => {
  const { open, closeDialog } = props;
  const [agencyName, setAgencyName] = useState<string>('');
  const { addNotification } = useNotificationHelper();

  const handleAgencyNameChange = (name: string) => {
    setAgencyName(name);
  };

  const approve = async () => {
    const agency: Agency = {
      agencyName: agencyName,
    };

    await agencyAPI
      .createAgency(agency)
      .then(() => {
        closeDialog();
        addNotification({
          type: 'success',
          message: `${agency.agencyName} saved successfully.`,
        });
      })
      .catch((error: any) => {
        addNotification({
          type: 'error',
          message: `${agency.agencyName} was unable to save.`,
        });
      });
  };

  return (
    <>
      {open ? (
        //#region dialog
        <CustomDialog
          open={open}
          title={'Create Agency'}
          toggleDialog={closeDialog}
          approveAction={approve}
          cancelAction={closeDialog}
        >
          <div className="code-textfield">
            <TextField
              onChange={(value: string) => {
                handleAgencyNameChange(value);
              }}
              title={'Agency Name'}
              fullwidth
            />
          </div>
        </CustomDialog>
      ) : //#endregion
      null}
    </>
  );
};
